import React from "react";

// Small decorative crescent + star SVG (gold)
export function CrescentStar({ className = "", size = 20 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      className={className}
      aria-hidden="true"
    >
      <path
        d="M22 8a10 10 0 1 0 0 16 8 8 0 1 1 0-16z"
        fill="currentColor"
      />
      <path
        d="M25 6l1.2 2.4L28.6 9.6 26.6 11l.4 2.6L25 12.5 23 13.6l.4-2.6L21.4 9.6 23.8 8.4 25 6z"
        fill="currentColor"
      />
    </svg>
  );
}

// Simple 8-point star ornament
export function EightStar({ className = "", size = 14 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      className={className}
      aria-hidden="true"
    >
      <path
        d="M16 0l3 13 13 3-13 3-3 13-3-13L0 16l13-3z"
        fill="currentColor"
      />
    </svg>
  );
}

// Ornamental divider with gold hairlines and center star
export function OrnamentDivider({ className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-4 ${className}`}>
      <div className="h-px w-16 md:w-24 bg-gradient-to-r from-transparent via-gold to-gold" />
      <EightStar className="text-gold" size={12} />
      <div className="h-px w-16 md:w-24 bg-gradient-to-l from-transparent via-gold to-gold" />
    </div>
  );
}

// Larger ornamental brand rule (used above headings)
export function SectionLabel({ children, className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-3 text-gold text-xs uppercase tracking-[0.28em] font-medium ${className}`}>
      <span className="h-px w-8 bg-gold/60" />
      <span>{children}</span>
      <span className="h-px w-8 bg-gold/60" />
    </div>
  );
}
